import { render, staticRenderFns } from "./DeleteAttributeModal.vue?vue&type=template&id=10bf63d4&"
import script from "./DeleteAttributeModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAttributeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports